import React from 'react';
import styled from 'styled-components';
import { QRData } from '../types/qr';
import { HandleInputChangeFunction } from './QRCodeGenerator';

interface URLBannerUploadFieldProps {
  qrData: QRData;
  handleInputChange: HandleInputChangeFunction;
}

export const URLBannerUploadField: React.FC<URLBannerUploadFieldProps> = ({
  qrData,
  handleInputChange,
}) => {
  return (
    <Label>
      Banner Image URL:
      <Input
        type="text"
        name="bannerUrl"
        value={qrData.url?.bannerUrl || ''}
        onChange={(e) => handleInputChange(e, 'url')}
        placeholder="Enter banner image URL"
      />
    </Label>
  );
};

const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: #1b294b;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #ff6320;
  }
`; 